module.exports = __webpack_public_path__ + "static/media/arrow_sx.945850fe.svg";